import * as _4 from 'lodash4';
import { IApplicationConfiguration } from '../../../models/app_config_model';
import { UserModesService } from '../../../user_modes/user_modes_service';
export class MyHeaderController {
  private isAccountHoldEnabled: boolean;
  private isStandaloneSchedulerEnabled: boolean = false;

  private ap3Url: string = '';

  private isPlannerActive: boolean = false;

  private isExplorerActive: boolean = false;

  private isPlanner3Active: boolean = false;
  private isPlanner3Enabled: boolean = false;

  private isStandaloneSchedulerActive: boolean = false;

  private reflectStateUpdatesBound: () => void;

  constructor(
    private FEATURE_ACCOUNT_HOLD_NK: string,
    private LEANAP_EXPOSE_LEANAP_APIS: string,
    private FEATURE_STANDALONE_SCHEDULER: string,
    private DefaultRoute: any,
    private $state: ng.ui.IStateService,
    private $rootScope: ng.IRootScopeService,
    private ngUserModesService: UserModesService,
    private appConfigModel: IApplicationConfiguration
  ) {}

  $onInit() {
    this.reflectStateUpdates();
    this.reflectStateUpdatesBound = this.$rootScope.$on('$stateChangeSuccess', this.reflectStateUpdates.bind(this));
  }

  $onChanges() {
    this.reflectStateUpdates();
  }

  $onDestroy() {
    // unsubscribing from the rootscope event
    this.reflectStateUpdatesBound();
  }

  reflectStateUpdates() {
    this.isAccountHoldEnabled = this.appConfigModel.isFeatureEnabled(this.FEATURE_ACCOUNT_HOLD_NK);
    this.isStandaloneSchedulerEnabled = this.appConfigModel.isFeatureEnabled(this.FEATURE_STANDALONE_SCHEDULER);

    this.ap3Url = this.ngUserModesService.isAdvisorOnly ? `#/my/ap3/advisor/` : `#/my/ap3/student/`;

    const AP3States = ['my.ap3'];
    this.isPlanner3Active = _.some(AP3States, this.$state.includes);
    this.isPlanner3Enabled = this.appConfigModel.isFeatureEnabled(this.LEANAP_EXPOSE_LEANAP_APIS);

    const AP1States = ['my.planner', 'my.routeModal.course_details', 'my.routeModal.courseDetails'];
    const schedulerState = 'my.schedule';
    if (!this.isStandaloneSchedulerEnabled) {
      AP1States.push(schedulerState);
    }
    this.isPlannerActive = _.some(AP1States, this.$state.includes);

    this.isStandaloneSchedulerActive = !this.isStandaloneSchedulerEnabled
      ? false
      : _.some(['my.standalonescheduler', schedulerState], this.$state.includes);

    this.isExplorerActive = this.isStandaloneSchedulerActive ? false : !this.isPlannerActive && !this.isPlanner3Active;
  }
}

export class MyHeaderComponent implements angular.IComponentOptions {
  public templateUrl: string = 'lib/header/components/my_header/my_header.html';
  public controller: any = MyHeaderController;
}



// WEBPACK FOOTER //
// ./app/lib/header/components/my_header/my_header.ts